import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
//import page
import Header from './Header.js'
import Home from './Pages/Home'
import Properties from './Pages/Properties.js';
import Agents from './Pages/Agents.js';
import Login from './Pages/Login.js';
import SignUp from './Pages/SignUp.js';
import Agent from './Pages/Agent.js';
import PropertyDetail from './Pages/PropertyDetail.js';
//loading
import BeatLoader from "react-spinners/BeatLoader";
import './App.scss';
import Footer from './Footer.js';


function App() {
  
  const [loading, setLoading] = useState(true)
  
  useEffect(()=>{
    const axios = require('axios');
    axios.get('https://skycurtain-api.herokuapp.com').then(res=>{
        setLoading(false)
    })
  },[loading])

  return (
    <Router>
       
      <React.Fragment>
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/Properties" component={Properties} />
          <Route exact path="/Agents" component={Agents} />
          <Route exact path="/Login" component={Login} />
          <Route exact path="/SignUp" component={SignUp} />
          <Route exact path="/Agent" component={Agent} />
          <Route exact path="/PropertyDetail" component={PropertyDetail} />
        </Switch>
        <Footer />
      </React.Fragment>
      
    </Router>
  );
}

export default App;
